import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY, ACCENT } from "../colors";

export const OneTapAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const cardAppear = spring({ frame, fps, config: { damping: 14 } });
  const fingerMove = interpolate(frame, [40, 65], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const buttonPress = frame >= 68 && frame <= 75;
  const checkmark = spring({ frame: frame - 78, fps, config: { damping: 12 } });
  const successBanner = spring({ frame: frame - 90, fps, config: { damping: 14 } });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        justifyContent: "center",
        alignItems: "center",
        padding: 48,
      }}
    >
      {/* Message card */}
      <div
        style={{
          transform: `scale(${cardAppear})`,
          opacity: cardAppear,
          width: "100%",
          maxWidth: 520,
          backgroundColor: "white",
          borderRadius: 20,
          padding: 32,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        {/* Review preview */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: GRAY[400], marginBottom: 8, letterSpacing: 1 }}>
            NEW REVIEW
          </div>
          <div style={{ fontSize: 20, color: GRAY[700], lineHeight: 1.5 }}>
            <span style={{ color: "#F59E0B" }}>★★★★★</span> &quot;Best auto shop in Denver!
            Fixed my brakes fast and fairly priced.&quot;
          </div>
        </div>

        {/* Suggested reply */}
        <div
          style={{
            backgroundColor: GRAY[50],
            borderRadius: 12,
            padding: 16,
            marginBottom: 24,
          }}
        >
          <div style={{ fontSize: 16, fontWeight: 600, color: BRAND[600], marginBottom: 6 }}>
            Suggested Reply
          </div>
          <div style={{ fontSize: 18, color: GRAY[600], lineHeight: 1.5 }}>
            Thanks for trusting Alpine Auto Repair, Mike! Our Denver team is glad we got your brakes sorted quickly. Drive safe!
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10, position: "relative" }}>
          <div
            style={{
              flex: 1,
              padding: "14px 0",
              borderRadius: 10,
              backgroundColor:
                frame >= 78 ? ACCENT[500] : buttonPress ? ACCENT[600] : ACCENT[500],
              color: "white",
              fontSize: 18,
              fontWeight: 700,
              textAlign: "center",
              transform: buttonPress ? "scale(0.95)" : "scale(1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
            }}
          >
            {frame >= 78 ? (
              <span style={{ transform: `scale(${checkmark})` }}>✓ Approved!</span>
            ) : (
              "✅ Approve"
            )}
          </div>
          <div
            style={{
              flex: 1,
              padding: "14px 0",
              borderRadius: 10,
              backgroundColor: GRAY[100],
              color: GRAY[600],
              fontSize: 18,
              fontWeight: 600,
              textAlign: "center",
              opacity: frame >= 78 ? 0.4 : 1,
            }}
          >
            ✏️ Edit
          </div>
          <div
            style={{
              flex: 1,
              padding: "14px 0",
              borderRadius: 10,
              backgroundColor: GRAY[100],
              color: GRAY[600],
              fontSize: 18,
              fontWeight: 600,
              textAlign: "center",
              opacity: frame >= 78 ? 0.4 : 1,
            }}
          >
            ⏭️ Skip
          </div>

          {/* Finger cursor */}
          {frame >= 40 && frame < 78 && (
            <div
              style={{
                position: "absolute",
                left: interpolate(fingerMove, [0, 1], [250, 70]),
                top: interpolate(fingerMove, [0, 1], [60, 8]),
                fontSize: 36,
                transform: buttonPress ? "scale(0.85)" : "scale(1)",
                filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
              }}
            >
              👆
            </div>
          )}
        </div>
      </div>

      {/* Success banner */}
      {frame >= 90 && (
        <div
          style={{
            position: "absolute",
            bottom: 44,
            transform: `translateY(${interpolate(successBanner, [0, 1], [20, 0])}px)`,
            opacity: successBanner,
            backgroundColor: ACCENT[500],
            color: "white",
            padding: "12px 28px",
            borderRadius: 24,
            fontSize: 18,
            fontWeight: 700,
            boxShadow: "0 4px 12px rgba(34,197,94,0.3)",
          }}
        >
          Reply posted to Google ✓
        </div>
      )}
    </AbsoluteFill>
  );
};
